<template>
  <BaseLayout
    title="A.R.C Score"
    :customClasses="['login']"
    :centerHeading="true">
    <AccountMigrationNotice />
    <div
      class="flex-center">
      <Button
        text="Sign in with Google"
        btnType="primary"
        :hasLink="false"
        @click="$auth.loginWithRedirect({ appState: { targetUrl: $auth.targetUrl || '/' } })" />
    </div>
    <p class="registration-link">New to ARC? <router-link to="/register">Create an account</router-link></p>
  </BaseLayout>
</template>

<script>
import Button from '@/components/form/Button'
import BaseLayout from '@/views/BaseLayout'
import AccountMigrationNotice from '@/components/auth/AccountMigrationNotice'

export default {
  name: 'Login',
  components: {
    Button,
    BaseLayout,
    AccountMigrationNotice
  }
}
</script>

<style lang="scss">
.flex-center {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
